export default __webpack_public_path__ + "static/media/SUV.8f615d3b.png";